<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import VisualSuccess from '../components/VisualSuccess.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import router from '@/router';
import { optimisticallyGetCommissionState } from '../utils/output-connections';
import { onMounted } from 'vue';
import { useDeviceSpecificationStore } from '../stores/deviceSpecificationStore';

const deviceSpecificationStore = useDeviceSpecificationStore();

onMounted(() => {
  optimisticallyGetCommissionState();
});

const goToProjectSection = () => {
  if (deviceSpecificationStore.hasAssignedSite) {
    router.push({ name: 'ConfigureSolshareConfirmSite' });
  } else {
    router.push({ name: 'ProjectSelect' });
  }
};
</script>

<template>
  <ProgressFrame pageClass="fullfocus-page">
    <div class="content">
      <VisualSuccess>
        <template #title>Great.<br />Update complete.</template>
      </VisualSuccess>

      <ButtonPrimary
        block
        class="cta-button"
        @click="goToProjectSection"
        data-tn="goto-project-btn"
      >
        Next
      </ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.cta-button {
  margin-top: 1.25rem;
}
</style>
